export default __webpack_public_path__ + "static/media/IQ.e27fa329.svg";